import {useFeatureIsOn} from "@growthbook/growthbook-react";

import {useFlagsCookie} from "@repo/data-cookies";

// Since GrowthBook useFeatureIsOn doesn't support forcing via cookies, this
// func is a workaround to check both the flag and the cookie, similar to
// our old flag system.
export function useFlagOrCookie(flagName: string): boolean {
    const featureFlag = useFeatureIsOn(flagName);
    const flagsCookieResult = useFlagsCookie(flagName);
    const flagsCookie =
        flagsCookieResult.status === "success"
            ? flagsCookieResult.value
            : undefined;

    const flag = Boolean(featureFlag || flagsCookie);

    return flag;
}
